import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { datiBilancioContributiPubbliciRules } from './dati-bilancio-contributi-pubblici.rules';
import { datiBilancioCertificazioneRules } from './dati-bilancio-certificazione.rules';
import { datiBilancioSocietaPartecipateRules } from './dati-bilancio-societa-partecipate.rules';
import { datiBilancioPrestitoSociRules } from './dati-bilancio-prestito-soci.rules';
import { datiBilancioRistorniRules } from './dati-bilancio-ristorni.rules';

export const datiBilancioRules: FormGroupRules = {
    ...datiBilancioContributiPubbliciRules,
    ...datiBilancioCertificazioneRules,
    ...datiBilancioSocietaPartecipateRules,
    ...datiBilancioPrestitoSociRules,
    ...datiBilancioRistorniRules,
};

export const datiBilancioFormValidators = Object.values(datiBilancioRules);
